<template>
    <VModalWrapper :title="title" v-on="listeners" v-bind="attributes" :showX="false">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <div class="active-form__field">
                    <label class="active-form__label active-form__label_required">
                        Оцените качество обслуживания
                    </label>
                    <div class="rating-stars">
                        <VStarIcon
                            v-for="star in 5"
                            :key="star"
                            :active="star <= (hoverRating || rating)"
                            @click.native="rating = star"
                            @mouseenter.native="hoverRating = star"
                            @mouseleave.native="hoverRating = 0"
                        />
                    </div>
                </div>

                <ValidationProvider
                    class="active-form__field"
                    name="comment"
                    :rules="rating > 0 && rating <= 3 ? 'required' : ''"
                    v-slot="{ errors }"
                >
                    <label
                        class="active-form__label"
                        :class="{ 'active-form__label_required': rating > 0 && rating <= 3 }"
                    >
                        <span v-if="rating > 0 && rating <= 3">Пожалуйста, укажите причину низкой оценки</span>
                        <span v-else>Комментарий</span>
                    </label>
                    <VContenteditable
                        name="comment"
                        class="active-form__control"
                        :class="{ error: errors[0] }"
                        v-model="comment"
                    ></VContenteditable>
                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <div class="active-form__actions">
                    <VButton type="submit" class="active-form__action button_green" :disabled="rating === 0">
                        Отправить
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>

<script>
import VButton from '../components/VButton/VButton.vue';
import VModalWrapper from '../components/VModalWrapper/VModalWrapper.vue';
import VContenteditable from '../components/VContenteditable/VContenteditable.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VStarIcon from '@/views/components/VStarIcon/VStarIcon.vue';

import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../js/enums/ModalNames';
import ModalMixin from '../../js/vue/mixins/ModalMixin';

@Component({
    components: {
        VButton,
        VModalWrapper,
        VContenteditable,
        ValidationObserver,
        ValidationProvider,
        VStarIcon,
    },
})
class VRequestRatingModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.REQUEST_ACCEPT_WORK })
    name;
    @Prop({ type: String, default: 'Принять работу' })
    defaultTitle;

    rating = 0;
    hoverRating = 0;
    comment = '';
    forceClose = false;

    submit() {
        this.resolve({
            rating: this.rating,
            comment: this.comment,
        });
        this.forceClose = true;
        this.hide();
    }

    beforeClose(event) {
        if (!this.forceClose) {
            event.stop();
            return false;
        }
        this.rating = 0;
        this.hoverRating = 0;
        this.comment = '';
        this.forceClose = false;
    }
}

export default VRequestRatingModal;
</script>

<style lang="scss">
.rating-stars {
    display: flex;
    gap: 8px;
    margin-top: 8px;
    justify-content: center;
}
</style>
